import React from 'react';

const AboutSection = ({ isArabic }) => {
  const companyName = {
    en: "Al Nakhla Exchange and Financial Services",
    ar: "شركة النخلة للصرافة والخدمات المالية"
  };
  const text = {
    en: {
      subtitle: "About Us",
      title: "About Us",
      briefDescription:
        `${companyName.en} is a Libyan company specialized in exchange services and financial solutions, established in 2013, and obtained a license to practice activity under a decision issued by the Central Bank of Libya No. (95) in 2025, to officially commence its operations at the beginning of 2026. We are committed to providing safe and reliable financial services that meet the needs of individuals and companies inside and outside Libya.`,
      commitment:
        `${companyName.en} seeks to contribute to the development of the banking and financial services sector in Libya, by providing professional services based on trust, transparency, and full compliance with applicable legislation and regulations. The company relies on qualified personnel and modern operating systems that ensure speed of completion and accuracy of operations, with a focus on customer satisfaction and building long-term relationships.`,
      companyInfoTitle: "Company Information",
      companyInfo: {
        name: "Company Name:",
        nameValue: companyName.en,
        license: "License to Practice:",
        licenseValue: "No. (95) issued by the Governor of the Central Bank of Libya",
        year: "Year of License:",
        yearValue: "2025",
        headquarters: "Company Headquarters:",
        headquartersValue: "Tripoli, Libya"
      },
      valuesTitle: "Our Values",
      values: [
        "Integrity and transparency",
        "Compliance with laws and regulations",
        "Protection of clients' funds and data",
        "Quality in service delivery",
        "Continuous development"
      ]
    },
    ar: {
      subtitle: "من نحن",
      title: "من نحن",
      briefDescription:
        `${companyName.ar} هي شركة ليبية متخصصة في خدمات الصرافة والحلول المالية، تأسست سنة 2013، وحصلت على إذن مزاولة النشاط بموجب قرار صادر عن مصرف ليبيا المركزي رقم (95) سنة 2025، لتباشر أعمالها رسميًا مطلع سنة 2026. نلتزم بتقديم خدمات مالية آمنة وموثوقة تلبي احتياجات الأفراد والشركات داخل ليبيا وخارجها.`,
      commitment:
        `تسعى ${companyName.ar} إلى الإسهام في تطوير قطاع الصيرفة والخدمات المالية في ليبيا، من خلال تقديم خدمات احترافية تعتمد على الثقة، الشفافية، والالتزام الكامل بالتشريعات والأنظمة المعمول بها. وتعتمد الشركة على كوادر مؤهلة وأنظمة تشغيل حديثة تضمن سرعة الإنجاز ودقة العمليات، مع التركيز على رضا العملاء وبناء علاقات طويلة الأمد.`,
      companyInfoTitle: "معلومات الشركة",
      companyInfo: {
        name: "اسم الشركة:",
        nameValue: companyName.ar,
        license: "إذن مزاولة النشاط:",
        licenseValue: "رقم (95) صادر عن محافظ مصرف ليبيا المركزي",
        year: "سنة صدور الإذن:",
        yearValue: "2025",
        headquarters: "مقر الشركة:",
        headquartersValue: "العاصمة الليبية – طرابلس"
      },
      valuesTitle: "قيمنا",
      values: [
        "النزاهة والشفافية",
        "الالتزام بالقوانين واللوائح",
        "حماية أموال وبيانات العملاء",
        "الجودة في تقديم الخدمات",
        "التطوير المستمر"
      ]
    }
  };

  const currentLang = isArabic ? 'ar' : 'en';

  const infoIcons = {
    name: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    license: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    year: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    headquarters: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    )
  };

  const infoItems = [
    { key: 'name', icon: infoIcons.name },
    { key: 'license', icon: infoIcons.license },
    { key: 'year', icon: infoIcons.year },
    { key: 'headquarters', icon: infoIcons.headquarters }
  ];

  return (
    <section id="about" className="py-12 sm:py-16 lg:py-20 bg-white relative overflow-hidden" dir={isArabic ? 'rtl' : 'ltr'}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 2xl:px-16 max-w-7xl">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <p className="text-xs sm:text-sm font-semibold tracking-wider mb-3 sm:mb-4 uppercase" style={{color: '#006655'}}>
            {text[currentLang].subtitle}
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black mb-4 sm:mb-8">
            {text[currentLang].title}
          </h2>
        </div>

        <div className="max-w-6xl mx-auto space-y-8 sm:space-y-12 lg:space-y-16">
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 shadow-lg border-2" style={{borderColor: '#E6F5F3'}}>
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center justify-center mb-4 sm:mb-6">
                <div className="w-12 sm:w-16 h-1 rounded-full" style={{backgroundColor: '#006655'}}></div>
                <div className="mx-3 sm:mx-4 w-2 sm:w-3 h-2 sm:h-3 rounded-full" style={{backgroundColor: '#006655'}}></div>
                <div className="w-12 sm:w-16 h-1 rounded-full" style={{backgroundColor: '#006655'}}></div>
              </div>
              <p className="text-base sm:text-lg lg:text-xl text-gray-700 leading-relaxed text-center">
                {text[currentLang].briefDescription}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            <div className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 border-2 relative overflow-hidden" style={{borderColor: '#E6F5F3'}}>
              <div className="absolute top-0 right-0 w-24 h-24 sm:w-32 sm:h-32 rounded-full opacity-20" style={{backgroundColor: '#006655', transform: 'translate(30%, -30%)'}}></div>
              <div className="absolute bottom-0 left-0 w-20 h-20 sm:w-24 sm:h-24 rounded-full opacity-20" style={{backgroundColor: '#006655', transform: 'translate(-30%, 30%)'}}></div>
              <div className="relative z-10">
                <div className="flex items-center mb-4 sm:mb-6">
                  <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center ${isArabic ? 'ml-3 sm:ml-4' : 'mr-3 sm:mr-4'}`} style={{backgroundColor: '#006655'}}>
                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold" style={{color: '#006655'}}>
                    {text[currentLang].companyInfoTitle}
                  </h3>
                </div>
                <div className="space-y-4 sm:space-y-5">
                  {infoItems.map((item) => (
                    <div key={item.key} className="flex items-start group">
                      <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform" style={{backgroundColor: '#F0F9F7', color: '#006655', marginRight: isArabic ? '0' : '0.75rem', marginLeft: isArabic ? '0.75rem' : '0'}}>
                        {item.icon}
                      </div>
                      <div className="flex-1">
                        <p className="text-xs sm:text-sm font-semibold mb-1 sm:mb-1.5" style={{color: '#006655'}}>
                          {text[currentLang].companyInfo[item.key]}
                        </p>
                        <p className="text-sm sm:text-base text-gray-800 font-medium">
                          {text[currentLang].companyInfo[`${item.key}Value`]}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #F0F9F7 0%, #E6F5F3 100%)'}}>
              <div className="absolute top-0 right-0 w-24 h-24 sm:w-32 sm:h-32 rounded-full opacity-20" style={{backgroundColor: '#006655', transform: 'translate(30%, -30%)'}}></div>
              <div className="absolute bottom-0 left-0 w-20 h-20 sm:w-24 sm:h-24 rounded-full opacity-20" style={{backgroundColor: '#006655', transform: 'translate(-30%, 30%)'}}></div>
              <div className="relative z-10">
                <div className="flex items-center mb-4 sm:mb-6">
                  <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center ${isArabic ? 'ml-3 sm:ml-4' : 'mr-3 sm:mr-4'}`} style={{backgroundColor: '#006655'}}>
                    <svg className="w-5 h-5 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold" style={{color: '#006655'}}>
                    {currentLang === 'en' ? 'Our Commitment' : 'التزامنا'}
                  </h3>
                </div>
                <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                  {text[currentLang].commitment}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;